import { render, staticRenderFns } from "./ConfigureDynamicAttributeOptions.vue?vue&type=template&id=9b473f88"
import script from "./ConfigureDynamicAttributeOptions.vue?vue&type=script&lang=js"
export * from "./ConfigureDynamicAttributeOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports